import React, { useEffect, useContext } from "react";
import { useStore } from "zustand";
import { getUrl, getPageData } from "../../../../constants";
import {
  postScrollUp,
  redirectIfResetIsRequired,
  resetRequired,
} from "../../../../utilities";

import { useLeadStore, useAppStateStore } from "../../../../stores";
import GlobalContext from "../../../context/global";
import { Loader } from "../../content";

const RoutePreLoader = ({ children, data }) => {
  const appData = useContext(GlobalContext);
  const {
    dealerProfile: { product },
  } = appData;
  const lead = useStore(useLeadStore);
  const url = `${product}.home`;

  useEffect(() => {
    useAppStateStore.setHistory(data.name);
    useAppStateStore.set({ current: getPageData(data.name) });
    if (!data.resetDisabled)
      redirectIfResetIsRequired(lead, getUrl(url), !!data.historyReplace);
    postScrollUp();
  }, [data.name]);

  return (
    (!resetRequired(lead) || data.resetDisabled) && (
      <>{children || <Loader fullPage={true} />}</>
    )
  );
};

export default RoutePreLoader;
